module.exports = __webpack_public_path__ + "img/midbef.2cfcf465.png";